import { createSmartrrModal } from "@vendor-app/utils/createModalStore";

export const useUpcomingOrderSkipModal = createSmartrrModal<{}>();
